import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-password-updated-message',
  imports: [CommonModule, RouterLink],
  templateUrl: './password-updated-message.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './password-updated-message.component.scss',
})
export class PasswordUpdatedMessageComponent {}
